import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { convertHtmlToReactDomWithParams } from '../../../../../utils/htmlUtils';

import './ErrorEbonPageBankTransferBlocStyle.scss';

const ErrorEbonPageBankTransferBloc = ({ show, paymentId, i18n }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="conteneur-color bank-transfer">
            <p>{convertHtmlToReactDomWithParams(i18n.TEXT_IBAN_1, paymentId)}</p>
            <div className="iban">
                <p className="label">{i18n.TEXT_IBAN_2}</p>
                <p>{i18n.TEXT_IBAN_3}</p>
                <p className="label">{i18n.TEXT_IBAN_4}</p>
                <p>{i18n.TEXT_IBAN_5}</p>
                <p className="small">{i18n.TEXT_IBAN_6}</p>
                <p className="label">{i18n.TEXT_IBAN_7}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT_IBAN_8)}</p>
                <p className="info">{convertHtmlToReactDomWithParams(i18n.TEXT_IBAN_9)}</p>
            </div>
        </div>
    );
};

ErrorEbonPageBankTransferBloc.propTypes = {
    show: PropTypes.bool,
    paymentId: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON.ERROR
    };
};

export default connect(mapStateToProps)(ErrorEbonPageBankTransferBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/banktransfer/ErrorEbonPageBankTransferBloc.js